'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const SVGRootView = require('common/ui/view/svg/root');
const FrameView = require('common/ui/view/svg/frame');
const GridView = require('common/ui/view/svg/grid');
const SVGCollectionView = require('common/ui/view/svg/collection');
const TextlabelView = require('common/ui/view/svg/text/label');
const RecordView = require('system/ui/view/element/record');
const RelationView = require('system/ui/view/element/relation');

module.exports = Mn.View.extend({
    template: false,

    initialize: function(params) {
        this._diagram = params.diagram;
        this._size = params.size;
        this._context = params.context;
        this._record = params.record;
        this._inoutRecords = params.inoutRecords;
        this._inRecords = params.inRecords;
        this._outRecords = params.outRecords;
        this._records = new Backbone.Collection();
        this._records.add(this._record);
        this._records.add(this._inoutRecords.models);
        this._records.add(this._inRecords.models);
        this._records.add(this._outRecords.models);
        this._relations = params.relations;
    },

    onRender: function() {
        const context = this.getOption('context');
        const members = this.getOption('members');
        const auth = this.getOption('auth');
        const root = new SVGRootView({
            centerOrigin: true,
            viewPort: {
                width: this._size.width,
                height: this._size.height
            }
        });
        this.$el.append(root.render().el);
        this.$el.css('opacity', 0);
        root.$el.attr('pointer-events', 'none');
        this._root = root;

        const canvasSize = 100000;
        const frame = new FrameView({
            size: {
                width: canvasSize,
                height: canvasSize
            },
            init: {
                scale: 0.2
            },
            scale: {
                min: 0.01,
                max: 1.0
            }
        });
        root.$el.append(frame.render().el);
        this._frame = frame;

        const grid = new GridView({
            width: canvasSize,
            height: canvasSize
        });
        frame.$el.append(grid.render().el);
        grid.show();

        const diagram = this._diagram;
        const RecordsView = SVGCollectionView.extend({
            className: 'records',
            childView: RecordView,
            initialize: function() {
                RecordsView.__super__.initialize.call(this);
                const nodeMetas = DiagramRepository.getNodeMetas({
                    context: context
                });
                this.listenTo(nodeMetas, 'change:is_zone', this.render);
                this.listenTo(nodeMetas, 'add', this.render);
            },
            buildChildView: function(d) {
                return new this.childView({
                    model: d,
                    meta: diagram.getNodeMeta(d.id),
                    diagram: diagram,
                    members: members,
                    context: context,
                    auth: auth,
                    draggable: false
                });
            },
            filter: function(child) {
                const meta = diagram.getNodeMeta(child.id);
                return !child.get('deleted') && meta &&
                    !meta.get('is_zone');
            }
        });
        const recordsView = new RecordsView({
            collection: this._records
        });

        const ZonesView = RecordsView.extend({
            className: 'zone',
            filter: function(child) {
                const meta = diagram.getNodeMeta(child.id);
                return !child.get('deleted') && meta &&
                    meta.get('is_zone');
            }
        });
        const zonesView = new ZonesView({
            collection: this._records
        });

        const RelationsView = SVGCollectionView.extend({
            className: 'relations',
            childView: RelationView,
            initialize: function() {
                RelationsView.__super__.initialize.call(this);
                this.listenTo(
                    DiagramRepository.getNodeMetas({
                        context: context
                    }),
                    'change:is_zone', this.render);
                this.listenTo(
                    DiagramRepository.getLinkMetas({
                        context: context
                    }),
                    'add', this.render);
                this.listenTo(
                    ElementRepository.getLinks({
                        context: context
                    }),
                    'change:source change:target', this.render);
            },
            buildChildView: function(d) {
                return new this.childView({
                    model: d,
                    meta: diagram.getLinkMeta(d.id),
                    context: context,
                    auth: auth,
                    findNodeView: function(model) {
                        const view = recordsView.children.findByModel(model);
                        if(!view) {
                            return zonesView.children.findByModel(model);
                        }
                        return view;
                    }
                });
            },
            filter: function(child) {
                return !child.get('deleted') &&
                    diagram.getLinkMeta(child.id);
            }
        });
        const relationsView = new RelationsView({
            collection: this._relations
        });

        // それぞれの View を適切な順番で render
        recordsView.render();
        frame.$el.append(zonesView.render().el);
        frame.$el.append(relationsView.render().el);
        frame.$el.append(recordsView.el);

        return this;
    },

    onDomRefresh: function() {
        setTimeout(_.bind(function() {
            this._size = {
                width: this.$el.parent().width(),
                height: this.$el.parent().width() * 0.7
            };
            this._root.resize({
                width: this._size.width,
                height: this._size.height
            });
            this.zoomTo();
            this._frame.disableZoom();
            this.addLabels(this._inoutRecords, 'io');
            this.addLabels(this._outRecords, 'o');
            this.addLabels(this._inRecords, 'i');
            this.$el.css('opacity', 1);
            this._frame.$el.selectAll('[pointer-events]').attr('pointer-events', 'none');
        }, this), 10);
    },

    zoomTo: function() {
        const rect = this._diagram.calcRectContainNodes(this._records.models);
        const initScale = 0.3;
        let scale = Math.min(
            this._size.width / rect.width,
            this._size.height / rect.height);
        scale = scale < initScale ? scale : initScale;
        scale = scale * 0.8;

        this._frame.zoomTo({
            x: rect.center.x,
            y: rect.center.y,
            scale: scale,
            duration: 0
        });
    },

    addLabels: function(records, prefix) {
        const g = this._frame.$el.append('g');
        const diagram = this._diagram;
        const scale = this._frame.scale();
        const labeledRecords = [];

        records
            .chain()
            .filter(function(r) {
                return diagram.hasNode(r);
            })
            .sortBy(function(r) {
                return diagram.getNodeMeta(r.id).y;
            })
            .each(function(r) {
                const meta = diagram.getNodeMeta(r.id);
                const v = new TextlabelView({
                    offset: {x: meta.x, y: meta.y},
                    size: 24 / scale,
                    text: prefix + (labeledRecords.length + 1)
                });
                g.append(v.render().el);
                labeledRecords.push(r);
            });

    }
});



// WEBPACK FOOTER //
// ./system/ui/view/detail/linked-node-diagram.js